import styled from "styled-components";

export const Main = styled.div`
  min-width: 150px;
  padding: 0;
`;

export const Styled = styled.div`
  min-width: 400px;

  .switch {
    margin-bottom: 0;
  }
  .select {
    &:not(:last-of-type) {
      margin-bottom: 7.5px;
    }
    h4 {
      width: 80px;
    }
  }
  .textInput {
    h4 {
      width: 95px;
    }
    &:not(:last-of-type) {
      margin-bottom: 7.5px;
    }
  }
  .textarea {
    > div {
      height: 60px;
      min-height: 60px;
    }
  }
  .authRow {
    display: flex;
    align-items: center;
    gap: 10px;
    justify-content: flex-end;
    margin-top: 6px;
    margin-bottom: 10px;
  }
  .authButton {
    padding: 8px 12px;
    border: none;
    border-radius: 6px;
    background: #0a7cff;
    color: #fff;
    font-weight: 600;
    cursor: pointer;
    
    &.remove {
      background: #d93025;

      &:hover {
        box-shadow: 0 0 10px #d93025;
      }
    }
  }
  .authButton:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  .authStatus {
    font-size: 12px;
  }
  .greenColor {
    color: #0f9d58;
  }
  .redColor {
    color: #d93025;
  }
`;